export const phoneRegExp = /^(0|\+\d{1,4})[\s\d]+$/;
export const classValidatorPhoneRegExp = /^\+?\d{1,3}?\s?\(?\d{3}\)?[\s.-]?\d{1,4}[\s.-]?\d{1,4}$/; // This is the regex which is used by the class-validator package in the backend
